import { CommonModule } from '@angular/common';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { ModalModule, ModalDirective } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AppComponent } from '../../app.component';
import { MfaTelephoneService } from '../../service/mfa-telephone.service';
import { MfaTelephoneMainComponent } from './mfa-telephone-main.component';
import { WebApiService } from '../../service/web-api.service';
import { DisplayService } from '../../service/display.service';
import { CheckItemService } from '../../service/checkItem.service';
import { CustomViewService } from '../../service/custom-view.service';
import { AuthService } from '../../service/auth.service';

import { MessageModalComponent } from '../message-modal/message-modal.component';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { environment } from '../../../environments/environment';

declare let gtag: any; // グローバル変数gtagを解決
@Component({
  selector: 'app-mfa-telephone',
  templateUrl: './mfa-telephone.component.html',
  styleUrls: ['./mfa-telephone.component.css'],
  providers: [DisplayService, CustomViewService, CheckItemService, MfaTelephoneService]
})
export class MfaTelephoneComponent implements OnInit {

  constructor(private compiler: Compiler, private customViewService: CustomViewService,
    private appComponent: AppComponent,
    private displayService: DisplayService, private checkItemService: CheckItemService, private mfaTelephoneService: MfaTelephoneService,
    public router: Router, private authService: AuthService, private activatedRoute: ActivatedRoute) { }

  @ViewChild('waitModal', { static: false }) waitModal: WaitModalComponent;
  @ViewChild('confirmModal', { static: false }) confirmModal: ConfirmModalComponent;
  @ViewChild('dest', { read: ViewContainerRef, static: false })
  public dest: ViewContainerRef;

  // 画面ID
  readonly SCREEN_ID = 'O09';

  // タイトルロゴ
  public dispZ0001: string;

  // ページ番号定義
  public pageNo: number;
  // 操作クラス定義
  public comp: MfaTelephoneMainComponent;

  // テンプレートファイ名（HTML）
  public templateHtml: string;

  // テンプレートファイル（CSS）
  public templateCss: string;

  // 画面資材ルートURL
  public assetsBaseUrl: string;

  // 共通画面資材URL
  public assetsPortalBaseUrl: string;

  // 電話番号
  public phoneNumber: string;

  public isMfaPage: boolean;

  public hasCompletePage: boolean;

  // サービス名
  public serviceName: string;

  /**
   * 初期処理
   */
  async ngOnInit() {
    this.pageNo = 1;

    if (this.appComponent.dispZ0000 === undefined) {
      await this.appComponent.getDisplayInfo();
    }

    // 読み込まれるHTML名の取得
    this.serviceName = '';
    if (this.appComponent.dispZ0000 === '') {
      this.serviceName = 'portal';
    } else {
      this.serviceName = this.appComponent.dispZ0000;
    }

    this.assetsBaseUrl = environment.storageBaseUrl + '/' + this.serviceName + '/adume';
    this.assetsPortalBaseUrl = environment.storageBaseUrl + '/portal';
    this.templateHtml = this.assetsBaseUrl + '/html/mfa-telephone/' + this.serviceName + '_mfa-telephone';
    this.templateCss = this.assetsBaseUrl + '/css/' + this.serviceName + '_mfa-telephone.css';

    // 画面カスタマイズ情報
    await this.displayService.execAuthDisplayInfo(this.SCREEN_ID).subscribe(data => {
      this.dispZ0001 = '';
      if (data.displayInfo != null) {
        if (data.displayInfo.Z0001 != null) {
          this.dispZ0001 = data.displayInfo.Z0001;
        }
      }

      this.phoneNumber = data.phoneNumber;
      if (this.phoneNumber == null) {
        this.phoneNumber = '';
      }
      // カスタムページ表示
      this.directInjection();
    });
  }
  /**
  * コンポーネントを生成し親コンポーネントに挿入する
  *
  */
  public async directInjection() {

    gtag('config', environment.analyticsId, {
      'page_path': this.templateHtml + '/' + this.pageNo,
      'page_title': 'mfa-telephone',
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'mfa-telephone',
      'page_location': this.serviceName + '/mfa-telephone/' + this.pageNo
    });

    // 元の要素をクリアする
    this.dest.clear();

    // テンプレートを取得
    let templateHtmlText = await this.customViewService.getText(this.templateHtml + '_' + this.pageNo + '.html').toPromise();
    let templateCssText = await this.customViewService.getText(this.templateCss).toPromise();
    templateCssText = templateCssText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsBaseUrl}}/g, this.assetsBaseUrl);
    templateHtmlText = templateHtmlText.replace(/{{assetsPortalBaseUrl}}/g, this.assetsPortalBaseUrl);


    // Angular コンポーネントを用意する
    @Component({
      selector: 'app-mfa-telephone-main',
      template: templateHtmlText,
      styles: [templateCssText],
    })

    class MfaTelephoneModuleComponent extends MfaTelephoneMainComponent { }
    // Angular モジュールを用意する

    @NgModule({
      imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
      declarations: [MfaTelephoneModuleComponent],
      exports: [MfaTelephoneModuleComponent]
    })
    class MfaTelephoneModule {
    }

    // Angular モジュールとコンポーネントをコンパイルする
    const module = this.compiler.compileModuleAndAllComponentsSync(MfaTelephoneModule);
    // Angular モジュールから ConsentOidcComponent を生成するファクトリを取り出す
    const factory = module.componentFactories.find((c) => {
      return c.componentType === MfaTelephoneModuleComponent;
    });

    // MfaTelephoneModuleComponent を生成し this.dest に設定する
    const componentRef = this.dest.createComponent(factory);

    // componentのインスタンスを取得する。
    this.comp = (<MfaTelephoneModuleComponent>componentRef.instance);
    this.comp.init(this, this.authService, this.checkItemService, this.waitModal, this.confirmModal, this.mfaTelephoneService);
  }
}
